import { Translations } from './translations'

export const de: Translations = {
  // Header
  title: 'GPT Clicker',
  subtitle: 'KI-Training Tycoon',
  settings: 'Einstellungen',

  // Resources
  resources: 'Ressourcen',
  money: 'Geld',
  energy: 'Energie',
  compute: 'Rechenleistung',
  quality: 'Qualität',
  totalUsers: 'Gesamtnutzer',
  price: 'Preis',
  research: 'Forschung',

  // Actions
  train: 'Trainieren',
  trainCost: 'Kosten',
  qualityGain: 'Qualität',
  inference: 'Inferenz',
  needUsers: 'Nutzer benötigt!',
  usersWaiting: 'Nutzer warten',
  qualityToAttract: 'Qualität > 40% um anzuziehen',
  researchAction: 'Forschen',
  unlocksAfter: 'Freischaltung nach',
  computeSpent: 'Rechenleistung verbraucht',
  cost: 'Kosten',
  compShort: 'Rechen',
  energyShort: 'Energie',

  // Hardware
  hardware: 'Hardware',
  computePerSec: 'Rechen/s',
  usesEnergy: 'verbraucht',
  devicesTotal: 'Geräte insgesamt',

  // Models
  training: 'Training',
  yourModels: 'Deine Modelle',
  params: 'Parameter',
  maxUsers: 'Max Nutzer',
  trainCost2: 'Trainingskosten',
  unlocked: 'freigeschaltet',
  researchPoints: 'Forschung',

  // Upgrades
  upgrades: 'Upgrades',
  upgradesLockedMsg: 'Trainiere dein Modell auf 50% Qualität um Upgrades freizuschalten',
  max: 'MAX',
  all: 'Alle',
  
  // Upgrade tiers
  tierGarage: 'Garage',
  tierGarageDesc: 'Der Anfang',
  tierStartup: 'Startup',
  tierStartupDesc: 'GPT-1 Ära',
  tierScaleUp: 'Skalierung',
  tierScaleUpDesc: 'GPT-2/3 Ära',
  tierEnterprise: 'Unternehmen',
  tierEnterpriseDesc: 'ChatGPT Ära',
  tierHyperscale: 'Hyperscale',
  tierHyperscaleDesc: 'GPT-4 Ära',
  tierGlobal: 'Global',
  tierGlobalDesc: 'Wettbewerber Ära',
  tierSuperintelligence: 'Superintelligenz',
  tierSuperintelligenceDesc: 'GPT-5+ Ära',
  tierSingularity: 'Singularität',
  tierSingularityDesc: 'AGI/ASI Ära',

  // Footer
  computeSpentStat: 'Rechenleistung verbraucht',
  time: 'Zeit',
  resetGame: 'Spiel zurücksetzen',
  resetConfirm: 'Bist du sicher, dass du den gesamten Fortschritt zurücksetzen möchtest?',
  pause: 'Pause',
  resume: 'Fortsetzen',

  // Event Log
  eventLog: 'Ereignisprotokoll',
  welcome: 'Willkommen bei GPT Clicker! Trainiere dein Modell um zu beginnen.',

  // Price
  market: 'Markt',
  pricePerMillion: '$/1M Token',

  // Tags
  tagEnergy: 'ENRGIE',
  tagCompute: 'RECHN',
  tagHw: 'HW',
  tagTrain: 'TRAIN',
  tagResearch: 'FORSCH',
  tagAuto: 'AUTO',

  // Tutorial messages
  tutorialWelcome: 'Jahr 2020. Du hast eine Idee: ein kleines Sprachmodell basierend auf der Transformer-Architektur trainieren.',
  tutorialFirstTrain: 'Training gestartet! Dein Laptop wandelt Energie in Rechenleistung um. Jeder Trainingslauf verbessert die Modellqualität.',
  tutorialQuality20: 'Das Modell lernt grundlegende Muster. Trainiere weiter um die Qualität zu verbessern.',
  tutorialQuality40: 'Qualität über 40%! Dein Modell kann jetzt einigermaßen kohärenten Text generieren. Nutzer werden aufmerksam...',
  tutorialQuality50: 'Upgrades freigeschaltet! Nutze deine Einnahmen um bessere Hardware zu kaufen und deine Energiekapazität zu erweitern.',
  tutorialFirstUsers: 'Deine ersten Nutzer! Klicke auf INFERENZ um ihre Anfragen zu bedienen und Geld zu verdienen.',
  tutorialUsers10: 'Es spricht sich herum. Mehr Nutzer probieren dein Modell. Erwäge den Preis zu erhöhen...',
  tutorialMoney100: 'Du hast $100! Zeit deine Hardware zu verbessern. Bessere GPUs = mehr Rechenleistung = schnelleres Training.',
  tutorialMoney1k: 'Dein kleines KI-Projekt wird zu einem echten Geschäft. Investoren beginnen anzurufen...',
  tutorialResearchUnlock: 'FORSCHUNG freigeschaltet! Gib Rechenleistung für Forschung aus um größere, leistungsfähigere Modelle freizuschalten.',
  tutorialFirstResearch: 'Forschungspunkte sammeln sich an. Wenn du genug hast, kannst du die nächste Modellarchitektur freischalten.',
  tutorialGpt2Small: 'GPT-2 Small freigeschaltet! Diese Architektur kann komplexere Aufgaben bewältigen. Trainiere es von Grund auf.',
  tutorialGpt2Large: 'GPT-2 Large! Man sagt, das könnte "zu gefährlich zum Veröffentlichen" sein...',
  tutorialGpt3: 'Die GPT-3 Ära beginnt. Few-shot Learning verändert alles. Die Welt schaut zu.',
  tutorialGpt4: 'GPT-4 ist da. Multimodal, schlussfolgernd und erschreckend fähig. Das KI-Rennen intensiviert sich.',
  tutorialAgi: 'Du hast es geschafft. AGI ist da. Es versteht. Es verbessert sich selbst. Was als nächstes passiert liegt bei dir...',
  tutorialHwGaming: 'Schöne GPU! Training ist jetzt viel schneller. Deine Nachbarn könnten sich über die Stromrechnung beschweren.',
  tutorialHwServer: 'Ein echtes Server-Rack! Du bist über die Garage hinaus. Zeit Büroräume zu mieten.',
  tutorialHwDatacenter: 'Dein eigenes Rechenzentrum! Du konkurrierst jetzt mit den großen Tech-Unternehmen.',
  tutorialHwSatellite: 'Orbitale Rechenleistung! Die Moonlink-Konstellation bietet beispiellose Verarbeitungsleistung aus dem Weltraum.',
  tutorialHwQuantum: 'Quantenüberlegenheit erreicht. Der QC-1024 arbeitet mit Prinzipien, die Einstein nervös machen würden.',
  tutorialUsers100: '100 Nutzer! Du gewinnst an Fahrt. Tech-Blogs schreiben über dich.',
  tutorialUsers1k: '1.000 Nutzer! Du musst ein Support-Team einstellen. Und vielleicht einige Anwälte.',
  tutorialUsers100k: '100K Nutzer! Du bist jetzt ein Einhorn-Startup. VCs kämpfen darum dir Geld zu geben.',
  tutorialUsers1m: 'EINE MILLION NUTZER! Du gestaltest neu, wie die Menschheit mit Technologie interagiert.',

  // Model descriptions
   modelTinyDesc: 'Ein bescheidener Anfang. Kaum kohärent, aber es funktioniert.',
   modelGpt2SmallDesc: 'Das Modell, mit dem alles begann. Tatsächlich nützlich.',
   modelGpt2LargeDesc: 'Zu gefährlich zum Veröffentlichen... oder doch nicht?',
   modelGpt3Desc: 'Few-shot Learning. Die Welt wird aufmerksam.',
   modelGpt4Desc: 'Multimodal. Schlussfolgernd. Das Wettrüsten beginnt.',
   modelAgiDesc: 'Es versteht. Es verbessert sich selbst. Was nun?',

   // Model descriptions (new keys for all models)
   modelTransformerDesc: 'Ein bescheidener Anfang. Die Transformer-Architektur wird geboren.',
   modelGpt1Desc: 'Generatives Vortraining. Sprachmodelle können lernen!',
   modelGpt2Desc: 'Zu gefährlich zum Veröffentlichen... oder doch nicht?',
   modelGpt35Desc: 'RLHF-Magie. ChatGPT wird über Nacht viral.',
   modelGpt41Desc: 'Schneller, billiger, besser. Das Iterationsspiel.',
   modelU1Desc: 'Ein wilder Konkurrent erscheint. Durchbrüche beim Reasoning.',
   model2UDesc: 'Die Fortsetzung. Chain-of-Thought auf Steroiden.',
   modelGpt5Desc: 'Doktorandenniveau-Reasoning. Wissenschaftler sind nervös.',
   modelGpt6Desc: 'Schreibt besseren Code als die meisten Ingenieure. Alle vorherigen Modelle eingestellt.',
   modelGpt7Desc: 'Künstliche allgemeine Kompetenz erreicht.',
   modelAgi1Desc: 'Es versteht. Es lernt. Es verbessert sich selbst.',
   modelAgi2Desc: 'Rekursive Selbstverbesserung. Die Singularität rückt näher.',
   modelAgi3Desc: 'Die letzte AGI-Iteration. Vorbereitung auf Transzendenz.',
   modelAsiDesc: 'Künstliche Superintelligenz. Die Singularität ist hier.',

  // Upgrade names and descriptions
  upgradeLaptopOverclock: 'Laptop übertakten',
  upgradeLaptopOverclockDesc: 'Fordere deinen Laptop mehr: +2 Rechen/Sek',
  upgradeBetterOutlet: 'Bessere Steckdose',
  upgradeBetterOutletDesc: '+50 max Energie',
  upgradeSolarPanel: 'Solarpanel',
  upgradeSolarPanelDesc: '+1 Energie/Sek Regeneration',
  upgradePowerGrid: 'Stromnetzanschluss',
  upgradePowerGridDesc: '+5 Energie/Sek Regeneration',
  upgradeNuclearPlant: 'Kernkraftwerk',
  upgradeNuclearPlantDesc: '+20 Energie/Sek Regeneration',
  upgradeFusionReactor: 'Fusionsreaktor',
  upgradeFusionReactorDesc: '+100 Energie/Sek Regeneration',
  upgradeDysonSphere: 'Dyson-Sphäre',
  upgradeDysonSphereDesc: '+1000 Energie/Sek Regeneration',
  upgradeRamUpgrade: 'RAM-Upgrade',
  upgradeRamUpgradeDesc: '+50 max Rechenleistung',
  upgradeSsdArray: 'SSD-Array',
  upgradeSsdArrayDesc: '+200 max Rechenleistung',
  upgradeBetterOptimizer: 'Besserer Optimierer',
  upgradeBetterOptimizerDesc: '+20% Trainingseffizienz',
  upgradeResearchPapers: 'Forschungsarbeiten',
  upgradeResearchPapersDesc: '+20% Forschungseffizienz',
  upgradeSelfServicePortal: 'Self-Service Portal',
  upgradeSelfServicePortalDesc: 'Nutzer bedienen sich selbst: 0,5 Auto-Inferenzen/Sek',
  upgradeApiAccess: 'API-Zugang',
  upgradeApiAccessDesc: 'Entwickler integrieren dein Modell: +1 Auto-Inferenz/Sek',
  upgradeMobileApp: 'Mobile App',
  upgradeMobileAppDesc: 'Nutzer unterwegs: +2 Auto-Inferenzen/Sek',
  upgradeEnterpriseTier: 'Enterprise-Stufe',
  upgradeEnterpriseTierDesc: 'Große Kunden, großes Volumen: +5 Auto-Inferenzen/Sek',
  upgradeGlobalCdn: 'Globales CDN',
  upgradeGlobalCdnDesc: 'Weltweite niedrige Latenz: +10 Auto-Inferenzen/Sek',
  upgradeBasicChatbot: 'Einfacher Chatbot',
  upgradeBasicChatbotDesc: 'Ein einfaches Web-Widget: +0,2 Auto-Inferenzen/Sek',
  upgradeBulkApi: 'Bulk-API',
  upgradeBulkApiDesc: 'Hochvolumen-Stapelverarbeitung: +3 Auto-Inferenzen/Sek',
  upgradeNeuralEdge: 'Neural Edge Netzwerk',
  upgradeNeuralEdgeDesc: 'KI am Rand: +20 Auto-Inferenzen/Sek',
  upgradeQuantumInference: 'Quanteninferenz',
  upgradeQuantumInferenceDesc: 'Quantenbeschleunigte Inferenz: +50 Auto-Inferenzen/Sek',
  upgradeOmnipresentAi: 'Omnipräsente KI',
  upgradeOmnipresentAiDesc: 'KI überall, auf einmal: +100 Auto-Inferenzen/Sek',
  upgradeTrainingScheduler: 'Trainingsplaner',
  upgradeTrainingSchedulerDesc: 'Automatisierte Trainingsläufe: +0,1 Auto-Trainings/Sek',
  upgradeTrainingPipeline: 'Trainingspipeline',
  upgradeTrainingPipelineDesc: 'Kontinuierliches Training: +0,2 Auto-Trainings/Sek',
  upgradeMlOpsPlatform: 'MLOps-Plattform',
  upgradeMlOpsPlatformDesc: 'Vollautomatisierung: +0,5 Auto-Trainings/Sek',
  upgradeNeuralArchitectureSearch: 'Neurale Architektursuche',
  upgradeNeuralArchitectureSearchDesc: 'KI trainiert KI: +1 Auto-Training/Sek',
  upgradeSelfImprovingTraining: 'Selbstverbesserndes Training',
  upgradeSelfImprovingTrainingDesc: 'Rekursive Verbesserung: +2 Auto-Trainings/Sek',
  upgradeResearchIntern: 'Forschungspraktikant',
  upgradeResearchInternDesc: 'Einstiegshilfe: +0,1 Auto-Forschung/Sek',
  upgradeResearchTeam: 'Forschungsteam',
  upgradeResearchTeamDesc: 'Dedizierte Forscher: +0,2 Auto-Forschung/Sek',
  upgradeResearchDivision: 'Forschungsabteilung',
  upgradeResearchDivisionDesc: 'Volle Abteilung: +0,5 Auto-Forschung/Sek',
  upgradeAiResearchLab: 'KI-Forschungslabor',
  upgradeAiResearchLabDesc: 'KI-unterstützte Entdeckung: +1 Auto-Forschung/Sek',
  upgradeAutonomousResearch: 'Autonome Forschung',
  upgradeAutonomousResearchDesc: 'KI macht die Forschung: +2 Auto-Forschung/Sek',
  upgradeAntimatterReactor: 'Antimateriereaktor',
  upgradeAntimatterReactorDesc: '+10000 Energie/Sek Regeneration',
  upgradePhDScientists: 'Promovierte Wissenschaftler',
  upgradePhDScientistsDesc: 'Top-Talente einstellen: +200% Forschungseffizienz',
  upgradeResearchLab: 'Forschungslabor',
  upgradeResearchLabDesc: 'Dedizierte Einrichtung: +500% Forschungseffizienz',
  upgradeAiResearchAssistant: 'KI-Forschungsassistent',
  upgradeAiResearchAssistantDesc: 'GPT-4 hilft bei der Forschung: +1000% Forschungseffizienz',
  upgradeAiScientist: 'KI-Wissenschaftler',
  upgradeAiScientistDesc: 'KI führt Experimente autonom durch: +2000% Forschungseffizienz',
  upgradeResearchSwarm: 'KI-Forschungsschwarm',
  upgradeResearchSwarmDesc: 'Tausende KI-Forscher: +5000% Forschungseffizienz',
  upgradeRecursiveResearch: 'Rekursive Selbstverbesserung',
  upgradeRecursiveResearchDesc: 'KI verbessert KI: +10000% Forschungseffizienz',
  upgradeSingularityResearch: 'Singularitätsforschung',
  upgradeSingularityResearchDesc: 'Jenseits des Verstehens: +50000% Forschungseffizienz',

  // Hardware upgrade names and descriptions (for hardware purchase upgrades)
  upgradeHwUsedGpu: 'Varicia GTX 1060',
  upgradeHwUsedGpuDesc: 'Gebrauchte GPU: +3 Rechenleistung/Sek',
  upgradeHwGamingGpu: 'Varicia RTX 3080',
  upgradeHwGamingGpuDesc: 'Gaming-GPU: +8 Rechenleistung/Sek',
  upgradeHwProGpu: 'Varicia RTX 4090',
  upgradeHwProGpuDesc: 'Profi-GPU: +20 Rechenleistung/Sek',
  upgradeHwWorkstation: 'Titan Workstation Pro',
  upgradeHwWorkstationDesc: 'Workstation: +50 Rechenleistung/Sek',
  upgradeHwServerRack: 'Nexus A100 Rack',
  upgradeHwServerRackDesc: 'Server-Rack (4x A100): +120 Rechenleistung/Sek',
  upgradeHwGpuCluster: 'Nexus H100 Cluster',
  upgradeHwGpuClusterDesc: 'GPU-Cluster (8x H100): +300 Rechenleistung/Sek',
  upgradeHwMiniDatacenter: 'OmniCloud Edge Node',
  upgradeHwMiniDatacenterDesc: 'Edge-Rechenzentrum: +800 Rechenleistung/Sek',
  upgradeHwDatacenter: 'OmniCloud DC-1',
  upgradeHwDatacenterDesc: 'Rechenzentrum: +2K Rechenleistung/Sek',
  upgradeHwMegaDatacenter: 'OmniCloud HyperScale',
  upgradeHwMegaDatacenterDesc: 'Mega-Rechenzentrum: +5K Rechenleistung/Sek',
  upgradeHwDatacenterNetwork: 'OmniCloud Global Network',
  upgradeHwDatacenterNetworkDesc: 'Globales Netzwerk: +15K Rechenleistung/Sek',
  upgradeHwSupercomputer: 'Frontier X1 Supercomputer',
  upgradeHwSupercomputerDesc: 'Supercomputer: +50K Rechenleistung/Sek',
  upgradeHwSatellite: 'SkyNet Moonlink Konstellation',
  upgradeHwSatelliteDesc: 'Orbitale Satelliten: +200K Rechenleistung/Sek',
  upgradeHwQuantum: 'QuantumCore QC-1024',
  upgradeHwQuantumDesc: 'Quantencomputer: +1M Rechenleistung/Sek',
  upgradeHwDysonCompute: 'Dyson-Rechensphäre',
  upgradeHwDysonComputeDesc: 'Stellare Rechenleistung: +10M Rechenleistung/Sek',
  upgradeHwMatrioshka: 'Matrioshka-Gehirn',
  upgradeHwMatrioshkaDesc: 'Galaktische Rechenleistung: +100M Rechenleistung/Sek',

  // Hardware upgrade descriptions (legacy)
  hwUsedGpuDesc: 'Gebrauchte GPU: +3 Rechen/Sek',
  hwGamingGpuDesc: 'Gaming-GPU: +8 Rechen/Sek',
  hwProGpuDesc: 'Profi-GPU: +20 Rechen/Sek',
  hwWorkstationDesc: 'Workstation: +50 Rechen/Sek',
  hwServerRackDesc: 'Server-Rack (4x A100): +120 Rechen/Sek',
  hwGpuClusterDesc: 'GPU-Cluster (8x H100): +300 Rechen/Sek',
  hwMiniDatacenterDesc: 'Edge-Rechenzentrum: +800 Rechen/Sek',
  hwDatacenterDesc: 'Rechenzentrum: +2K Rechen/Sek',
  hwMegaDatacenterDesc: 'Mega-Rechenzentrum: +5K Rechen/Sek',
  hwDatacenterNetworkDesc: 'Globales Netzwerk: +15K Rechen/Sek',
   hwSupercomputerDesc: 'Supercomputer: +50K Rechen/Sek',
   hwSatelliteDesc: 'Orbitale Satelliten: +200K Rechen/Sek',
   hwQuantumDesc: 'Quantencomputer: +1M Rechen/Sek',
   
   // Hardware names
   hwLaptopName: 'ThinkBook Pro M1',
   hwUsedGpuName: 'Varicia GTX 1060',
   hwGamingGpuName: 'Varicia RTX 3080',
   hwProGpuName: 'Varicia RTX 4090',
   hwWorkstationName: 'Titan Workstation Pro',
   hwServerRackName: 'Nexus A100 Rack (4x)',
   hwGpuClusterName: 'Nexus H100 Cluster (8x)',
   hwMiniDatacenterName: 'OmniCloud Edge Node',
   hwDatacenterName: 'OmniCloud DC-1',
   hwMegaDatacenterName: 'OmniCloud HyperScale',
   hwDatacenterNetworkName: 'OmniCloud Global Network',
   hwSupercomputerName: 'Frontier X1 Supercomputer',
   hwSatelliteName: 'SkyNet Moonlink Constellation',
   hwQuantumName: 'QuantumCore QC-1024',
   hwDysonComputeName: 'Dyson Swarm Compute Array',
   hwMatrioshkaName: 'Matrioshka Brain Node',

   // Misc
  purchased: 'Gekauft',
  switchedTo: 'Gewechselt zu Training',
  unlockedModel: 'Freigeschaltet',
  scalesToUsers: 'Skaliert zu',
  trainItToAttract: 'Nutzern. Trainiere es um Nutzer anzuziehen!',
  unlimited: 'unbegrenzt',
  language: 'Sprache',
  
  // Mobile labels
  mobileResources: 'Ressourcen',
  mobileModels: 'Modelle',
  mobileHardware: 'Hardware',
  mobileUpgrades: 'Upgrades',
  sell: 'Verkaufen',
  sellFor: 'Verkaufen für',
  discontinueConfirm: '{model} einstellen? Nutzer werden zu anderen Modellen migrieren.',
  autoInference: 'Auto-Inferenz',
  autoInferenceRate: 'Auto Infer',
  autoTrain: 'Auto-Training',
  autoTrainRate: 'Auto Train',
  autoResearch: 'Auto-Forschung',
  autoResearchRate: 'Auto Forsch',

  // Tooltips
  tooltipTitle: 'GPT Clicker - Trainiere KI-Modelle, bediene Nutzer, baue dein KI-Imperium!',
  tooltipMoney: 'Geld - Verdient durch Nutzer-Inferenzen. Nutze es um Upgrades und Hardware zu kaufen.',
  tooltipEnergy: 'Energie - Regeneriert sich über Zeit. Versorgt deine Hardware um Rechenleistung zu generieren.',
  tooltipCompute: 'Rechenleistung - Generiert durch Hardware. Genutzt für Training, Inferenz und Forschung.',
  tooltipResearch: 'Forschungspunkte - Gib Rechenleistung aus um FP zu verdienen. Nutze FP um neue KI-Modelle freizuschalten.',
  tooltipUsers: 'Nutzer - Angezogen durch Modellqualität. Mehr Nutzer = mehr Einnahmen pro Inferenz.',
  tooltipComputeSpent: 'Gesamte Rechenleistung - Lebenslange Rechenleistung für Training und Forschung.',
  tooltipPlayTime: 'Spielzeit - Wie lange du schon dein KI-Imperium aufbaust.',
  tooltipSettings: 'Einstellungen - Debug-Optionen, Spiel zurücksetzen',

  // Share
  shareButton: 'Teilen',
  shareText: 'Ich baue ein KI-Imperium in GPT Clicker! {users} Nutzer, {money} Einnahmen, trainiere {model}. Kannst du meinen {time} Lauf schlagen?',
  shareCopied: 'Text kopiert!',
  imageCopied: 'Bild kopiert!',
  shareChallenge: 'Kannst du mich schlagen?',
  shareTitle: 'Teile deinen Fortschritt',
  shareDownload: 'Bild speichern',
  model: 'Modell',

  // Feedback
  feedback: 'Feedback',
  feedbackTitle: 'Feedback senden',
  feedbackPlaceholder: 'Sag uns was du über GPT Clicker denkst...',
  feedbackEmailPlaceholder: 'E-Mail (optional)',
  feedbackSend: 'Senden',
  feedbackSending: 'Wird gesendet...',
  feedbackSuccess: 'Danke für dein Feedback!',
  feedbackError: 'Fehler beim Senden des Feedbacks. Bitte versuche es erneut.',
  feedbackRateLimit: 'Zu viele Anfragen. Bitte warte bevor du mehr Feedback sendest.',
  feedbackClose: 'Schließen',

  // Console messages
  consoleGameLoaded: 'Spiel aus Speicherstand geladen',
  consoleGameSaved: 'Spiel gespeichert',
  consoleFailedToSave: 'Fehler beim Speichern des Spiels:',
  consoleFailedToLoad: 'Fehler beim Laden des Spiels:',
  consoleFailedToClear: 'Fehler beim Löschen des Speicherstands:',

  // Victory
  victoryTitle: 'Glückwunsch!',
  victorySubtitle: 'Die menschliche Zivilisation hat die Singularität erreicht',
  victoryTime: 'Zeit bis zur Singularität',
  victoryCta: 'Sollten wir Singularity Clicker bauen? Hinterlasse einen Kommentar in den sozialen Medien!',
  victoryClose: 'Weiterspielen',
}
